const state = {
  companies: [],
};

const getters = {
  get: state => state.companies,
  isMultiCompany: state => state.companies.length > 1,
  companySelected: state => state.companies.find(company => company.selected),
};

const mutations = {
  SET(state, data) {
    state.companies = _.isArray(data) ? data : [];
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
